import React from 'react';
import { SvgIcon } from '@material-ui/core';

const wrapSvgPath = (path, viewBox = '0 0 24 24') => props => (
  <SvgIcon {...props} viewBox={viewBox}>{path}</SvgIcon>
);

export default wrapSvgPath;
